import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Capacidades, Fuente, RubroInfo, TasaBcv, UltimosData } from '@/shared/domain/types';

/**
 * Última respuesta buena de los endpoints públicos "ligeros". Permite pintar al instante y funcionar
 * sin conexión (junto con la caché del service worker). Los históricos NO se guardan aquí.
 */
export interface Snapshot<T> {
  data: T;
  /** Date.now() al guardar. */
  savedAt: number;
}

export interface MercadoState {
  ultimos: Snapshot<UltimosData> | null;
  bcv: Snapshot<TasaBcv> | null;
  fuentes: Snapshot<Fuente[]> | null;
  rubros: Snapshot<RubroInfo[]> | null;
  capacidades: Snapshot<Capacidades> | null;
}

export type MercadoKey = keyof MercadoState;

const initialState: MercadoState = {
  ultimos: null,
  bcv: null,
  fuentes: null,
  rubros: null,
  capacidades: null,
};

const mercadoSlice = createSlice({
  name: 'mercado',
  initialState,
  reducers: {
    saveSnapshot(state, a: PayloadAction<{ key: MercadoKey; data: unknown }>) {
      (state as Record<string, unknown>)[a.payload.key] = {
        data: a.payload.data,
        savedAt: Date.now(),
      };
    },
    clearMercado() {
      return initialState;
    },
  },
});

export const { saveSnapshot, clearMercado } = mercadoSlice.actions;
export const mercadoReducer = mercadoSlice.reducer;
